export default __webpack_public_path__ + "img/eetlienG.93760710.svg";